<template>
    <div class="tag-wrapper">
        <p>{{ $t('current_plan') }}</p>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    name: 'CurrentPlanTag'
});
</script>

<style lang="less" scoped>
.tag-wrapper{
    background: rgba(54, 137, 255, 0.2);
    padding: 2px 10px;
    color: @brand_light;
    font-size: 14px;
    border-radius: 4px;
    p{
        font-weight: 500;
    }
}
</style>
